import { FacebookEvents } from '@components/utils/constants'
import {
  IProductResponseWarperWithResultArray,
  IProductResponseWarperWithResultObj,
} from './productResponse.model'
import { getSHA256Hash } from '@framework/utils/cipher'
import { facebookEventHandler } from 'hooks/facebook-conversion'
import { IProduct } from '@components/utils/model/product.model'
import { IProductListResponse } from '@framework/api/operations/get-all-products'
import {
  getBrowserIdForFBConversion,
  getIpAddressForFBConversion,
  getDateOfBirthHash,
  getGenderHash,
  getCurrentPage,
} from '@framework/utils/app-util'

export const defaultYOffset = (window: any) => {
  if (typeof window !== 'undefined') {
    return window?.pageYOffset
  }
  return 0
}

export const transformProductResult = (
  productResponse: any
): { products: IProductListResponse } => {
  let results: any[] = []
  if (Object.keys(productResponse?.products?.results).length) {
    Object.keys(productResponse?.products?.results).forEach((datum) => {
      results = results.concat(productResponse?.products?.results?.[datum])
    })
  }
  return {
    products: {
      ...productResponse.products,
      results,
    },
  }
}

export const pageView = async (user: any) => {
  const mobileNumber = user?.mobile || user?.telephone
  let facebookeventData: any = {
    data: [
      {
        event_name: FacebookEvents.PAGE_VIEW,
        event_time: Math.floor(new Date().getTime() / 1000),
        action_source: 'website',
        user_data: {
          em: [user?.email ? await getSHA256Hash(user?.email) : ''],
          ph: mobileNumber ? await getSHA256Hash(mobileNumber) : null,
          fn: user?.firstName ? await getSHA256Hash(user?.firstName) : null,
          ln: user?.lastName ? await getSHA256Hash(user?.lastName) : null,
          client_user_agent: window.navigator.userAgent,
          fbp: getBrowserIdForFBConversion(),
          client_ip_address: (await getIpAddressForFBConversion()) || null,
          external_id: mobileNumber ? await getSHA256Hash(mobileNumber) : null,
          db: await getDateOfBirthHash(user),
          ge: await getGenderHash(user?.gender),
          ct: null,
          zp: null,
          country: await getSHA256Hash('in'),
        },
        custom_data: {
          content_name: getCurrentPage(),
        },
      },
    ],
  }

  facebookEventHandler(facebookeventData)
}
